import { AIContext } from 'contexts/AIContext';
import { CompanyContext } from 'contexts/CompanyContext';
import { useContext, useEffect, useState } from 'react'
import { aiListTextToArray } from 'utils/aiListTextToArray';

const useBrainstormContexts = () => {

  const { getByQueryChat } = useContext(AIContext);
  const { company } = useContext(CompanyContext);

  const getBrainstormContexts = async (query = ``, qty = 15, others = [], chargeable = true) => {
    const _query = `
      TOPIC: ${query}

      Brainstorm ${qty} ideas for ${company?.name} for social media posts based on the given TOPIC. 

      INSTRUCTIONS: 
      - Separate each idea using a new line. 
      - Each idea must have less than 10 words.
      - Do not answer in list format. 
      - Do not numarate every option. 

      MORE INSTRUCTIONS:
      - Include related topics from the given topic
      - You can start with the following phrases or come up with new phrases:
        - "Quick tipcs:"
        - "Industry myths:"
        - "Common mistakes:"
        - "Personal story:"
        - "Frecuently asked questions:"
        - "Step by steps:"
        - "Fun fact:"
        - "Questions:"
        - "Testimonials:"
        - "Quotes:"
        - "Education:"
        - "Polls:"
        - "Holiday:"

      ${!!others?.length ? `Make them different from the following ideas: ${others?.join(`\n`)}` : ``}

      Ideas: 
    `;

    let ideas = await getByQueryChat(_query, chargeable, undefined, undefined, undefined, undefined, undefined, undefined).then((response) => response);
    
    return aiListTextToArray(ideas);
  }

  return { getBrainstormContexts }
}

export default useBrainstormContexts;
